module.exports = "/_next/static/images/teacher-7-ee0d0d77e6c567268d7f8880c88a2d77.png";